module.exports = __webpack_public_path__ + "img/visa-electron-alternate.c199bd3c.png";